module.exports = {
    email: "semiquz@semiquz.co.kr",
    name: "SEMIQUZ",
    password: "a1234567!"
}
